export default {
    successDirectPayment: 'Payment was successful. Access is open.',
    failDirectPayment: 'Payment failed. Try to pay again. If the error repeats —',
    failDirectPaymentLink: 'contact technical support.'
};
